export default __webpack_public_path__ + "static/media/TL15.bb39ea09.mp3";